module.exports = __webpack_public_path__ + "img/ic_low.25b19ce0.svg";